export enum TaskActionType {

  // Create
  CreateTask          = 'CREATE_TASK',
  CreateSurveyTask    = 'CREATE_SURVEY_TASK',
  CreateTaskCompleted = 'CREATE_TASK_COMPLETED',
  CreateTaskFailed    = 'CREATE_TASK_FAILED',

  // Update
  UpdateTask          = 'UPDATE_TASK',
  UpdateTaskCompleted = 'UPDATE_TASK_COMPLETED',
  UpdateTaskFailed    = 'UPDATE_TASK_FAILED',

  // Close
  CloseTask          = 'CLOSE_TASK',
  CloseTaskCompleted = 'CLOSE_TASK_COMPLETED',
  CloseTaskFailed    = 'CLOSE_TASK_FAILED',

  // Load
  LoadTasks           = 'LOAD_TASKS',
  LoadTasksCompleted  = 'LOAD_TASKS_COMPLETED',
  LoadTasksFailed     = 'LOAD_TASKS_FAILED',

  // Load Templates
  LoadTaskTemplates           = 'LOAD_TASK_TEMPLATES',
  LoadTaskTemplatesCompleted  = 'LOAD_TASKS_TEMPLATES_COMPLETED',
  LoadTaskTemplatesFailed     = 'LOAD_TASKS_TEMPLATES_FAILED',

  // Select
  SelectTask          = 'SELECT_TASK',
  SelectTaskCompleted = 'SELECT_TASK_COMPLETED',
  SelectTaskFailed    = 'SELECT_TASK_FAILED',

}
